// extracted by mini-css-extract-plugin
export default {"linkIcon":"PopupLink-module-linkIcon","linkText":"PopupLink-module-linkText"};